import { useTheme } from '@mui/material/styles';
import { css } from '@emotion/css';
import React from 'react';

/**
 * Higher-Order Component that provides Material-UI v5 styled functionality
 * to class components, similar to the old withStyles HOC
 */
export const withStyles = (stylesOrCreator) => (Component) => {
  function StyledComponent(props) {
    const theme = useTheme();

    // Generate styles - can be object or function
    const styles =
      typeof stylesOrCreator === 'function'
        ? stylesOrCreator(theme)
        : stylesOrCreator;

    // Convert styles to CSS-in-JS classes using emotion
    const classes = {};
    Object.keys(styles).forEach((key) => {
      classes[key] = css(styles[key]);
    });

    return <Component {...props} classes={classes} theme={theme} />;
  }

  StyledComponent.displayName = `withStyles(${Component.displayName || Component.name})`;

  return StyledComponent;
};

/**
 * Higher-Order Component that provides theme access to class components
 */
export const withTheme = (Component) => {
  function ThemedComponent(props) {
    const theme = useTheme();
    return <Component {...props} theme={theme} />;
  }

  ThemedComponent.displayName = `withTheme(${Component.displayName || Component.name})`;

  return ThemedComponent;
};

export default withStyles;
